import { motion } from "framer-motion";
import SectionHeader from "./SectionHeader";

const STATS = [
  { k: "6", v: "Arenas" },
  { k: "1", v: "Day" },
  { k: "∞", v: "Ambitious Ideas" },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-20 sm:py-24 md:py-32 bg-[#0A0A0A]">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-12">
        <SectionHeader
          eyebrow="About"
          title={<><span className="text-marble">The Legend of </span><span className="italic text-gold-gradient">Tradella</span></>}
          testId="about-header"
        />
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="mt-10 max-w-3xl space-y-5 text-white/70 leading-relaxed text-base md:text-lg font-light"
        >
          <p>
            Tradella is <span className="text-[#B8873B]">Harvest International School&apos;s</span> flagship
            business and commerce fest, where young minds step out of the classroom and straight into the
            boardroom. Across six high-energy events, participants are challenged to think fast, argue sharp,
            negotiate hard, and lead with absolute confidence in a competitive, immersive environment.
          </p>
          <p>
            From intense courtrooms and fast-paced trading floors to strategic auction tables and high-stakes
            pitch decks, students step into the roles of lawyers, investors, franchise owners, marketers,
            crisis managers, and entrepreneurs — testing their real-world acumen head-on.
          </p>
          <p>
            It is the ultimate arena for the next generation of business leaders to prove they have what it
            takes to survive — and thrive — in the corporate world.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-3 gap-px bg-[#B8873B]/20">
          {STATS.map((s, i) => (
            <motion.div
              key={s.v}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-[#0A0A0A] p-6 md:p-8"
              data-testid={`about-stat-${i}`}
            >
              <div className="font-display text-3xl md:text-4xl text-gold-gradient">{s.k}</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-white/50 mt-2">{s.v}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
